import { makeStyles } from "tss-react/mui"
import { blueGrey, lightGreen } from "../../../../../../mp-core/themes/palette"

export const useStyles = makeStyles<{
  isStepOpen: boolean
  isLastStep: boolean
  hasViewedStep: boolean
  isNotSteppable: boolean
}>()(
  (
    { spacing, palette },
    { isStepOpen, isLastStep, hasViewedStep, isNotSteppable }
  ) => ({
    stepBadge: {
      width: "26px",
      height: "26px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "0.875rem",
      lineHeight: "1.0394rem ",
      color: palette.common.white,
      backgroundColor: blueGrey[400],
      borderRadius: "50px",

      ...(hasViewedStep && {
        backgroundColor: blueGrey[700]
      }),

      ...(isStepOpen && {
        backgroundColor: lightGreen[700]
      }),

      ...(isNotSteppable && {
        backgroundColor: blueGrey[700]
      })
    },
    stepContentContainer: {
      margin: spacing(2, 3),
      padding: `${spacing(2)} 29px`,

      ...(!isLastStep && {
        borderLeft: `1px solid ${blueGrey[100]}`
      }),

      ...(!isStepOpen &&
        !isLastStep && {
          height: "30px"
        })
    }
  })
)
